import { useState } from "react";

import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import TextareaAutosize from "@mui/material/TextareaAutosize";

import GridSectionHeader from "../../widgets/GridSectionHeader";
import GridTextfield from "../../widgets/GridTextfield";
import GridDropdown from "../../widgets/GridDropdown";

import { reDecimalNumbers } from "../../../utils/fieldValidator.js";
import {
  MAX_LENGTH_TEXTAREA,
  INVESTMENT_SOURCE_TYPE_DATA,
} from "../../../utils/constants.js";

export default function ExistingInvestment() {
  const [investmentDisclosure, setInvestmentDisclosure] = useState("");
  const [existingInvestmentDesc, setExistingInvestmentDesc] = useState("");

  const [investmentType, setInvestmentType] = useState("");
  const [cashCpfSrs, setCashCpfSrs] = useState("");
  const [investmentAmount, setInvestmentAmount] = useState("");
  const [currentValue, setCurrentValue] = useState("");

  function handleInvestmentDisclosureChange(e) {
    setInvestmentDisclosure(e.target.value);
  }

  function handleInvestmentTypeChange(e) {
    setInvestmentType(e.target.value);
  }

  function handleCashCpfSrsChange(e) {
    setCashCpfSrs(e.target.value);
  }

  function handleInvestmentAmountChange(e) {
    if (reDecimalNumbers.test(e.target.value))
      setInvestmentAmount(e.target.value);
  }

  function handleCurrentValueChange(e) {
    if (reDecimalNumbers.test(e.target.value)) setCurrentValue(e.target.value);
  }

  function handleExistingInvestmentDeschange(e) {
    if (e.target.value.length <= MAX_LENGTH_TEXTAREA)
      setExistingInvestmentDesc(e.target.value);
  }

  return (
    <Grid container spacing={2}>
      {/* EXISTING INVESMENTS */}
      <GridSectionHeader
        sectionName="Existing Investment"
        sx={{
          p: 1,
          pl: 1.8,
          mt: 0,
          mb: 1,
          fontSize: 18,
          fontWeight: "bold",
          color: "#FFFFFF", //WHITE
          // color: "#000000", //BLACK
          // backgroundColor: "#d9d9d9",
          backgroundColor: "#10B981",
        }}
      />

      {/*==============================
        EXISTING INVESTMENT - DECLARATION
      ==============================*/}
      <Typography variant="h6" gutterBottom>
        Do you have any exisitng investments to disclose?
      </Typography>

      <RadioGroup
        name="investment-disclosure"
        defaultValue=""
        value={investmentDisclosure}
        onChange={handleInvestmentDisclosureChange}
      >
        <FormControlLabel
          id="investmentYes"
          value="INVESTMENT_YES"
          control={<Radio />}
          label="Yes, I have existing investment(s) to disclose."
        />

        <FormControlLabel
          id="investmentNone"
          value="INVESTMENT_NONE"
          control={<Radio />}
          label="I do not have any investments."
        />

        <FormControlLabel
          id="investmentConfidential"
          value="INVESTMENT_CONFIDENTIAL"
          control={<Radio />}
          label="I do not wish to disclose my existing investment information and for it to be taken into consideration for needs analysis and recommendations."
        />
      </RadioGroup>

      {investmentDisclosure === "INVESTMENT_YES" ? (
        <>
          {/*==============================
        EXISTING INVESTMENT - DETAILS
        ==============================*/}
          <GridTextfield
            id="investmentType"
            columnSize="6"
            label="Type Of Investment"
            currState={investmentType}
            onChange={handleInvestmentTypeChange}
          />

          <GridDropdown
            id="cashCpfSrs"
            key="cashCpfSrs"
            columnSize="6"
            label="Cash/Cpf/Srs"
            defaultValue=""
            value=""
            currState={cashCpfSrs}
            onChange={handleCashCpfSrsChange}
            data={INVESTMENT_SOURCE_TYPE_DATA}
          />

          <GridTextfield
            id="investmentAmount"
            columnSize="6"
            label="Investment Amount(SP/RSP)"
            currState={investmentAmount}
            onChange={handleInvestmentAmountChange}
          />

          <GridTextfield
            id="currentValue"
            columnSize="6"
            label="Current Value"
            currState={currentValue}
            onChange={handleCurrentValueChange}
          />
        </>
      ) : (
        ""
      )}

      {/*==============================
        EXISTING INVESTMENT - DETAILS
        ==============================*/}
      {/* <GridTextfield
        id="investmentType"
        columnSize="6"
        label="Type Of Investment"
        currState={investmentType}
        onChange={handleInvestmentTypeChange}
      />

      <GridDropdown
        id="cashCpfSrs"
        key="cashCpfSrs"
        columnSize="6"
        label="Cash/Cpf/Srs"
        defaultValue=""
        value=""
        currState={cashCpfSrs}
        onChange={handleCashCpfSrsChange}
        data={INVESTMENT_SOURCE_TYPE_DATA}
      />

      <GridTextfield
        id="investmentAmount"
        columnSize="6"
        label="Investment Amount(SP/RSP)"
        currState={investmentAmount}
        onChange={handleInvestmentAmountChange}
      />

      <GridTextfield
        id="currentValue"
        columnSize="6"
        label="Current Value"
        currState={currentValue}
        onChange={handleCurrentValueChange}
      /> */}

      {/*==============================
        EXISTING INVESTMENT - ADDITIONAL NOTES
        ==============================*/}
      <Grid size={12}>
        {investmentDisclosure === "INVESTMENT_CONFIDENTIAL" ? (
          <>
            <Typography variant="body1">Additional Notes</Typography>

            <TextareaAutosize
              id="existingInvestmentDesc"
              placeholder="Type here..."
              style={{ width: "100%" }}
              minRows={5}
              onChange={handleExistingInvestmentDeschange}
            />
          </>
        ) : (
          ""
        )}
      </Grid>
    </Grid>
  );
}
